/**
      *********************************************************
      Description: Textbox component. .
      Required props:  type,value.
      limitations    : N/A.
      *********************************************************
**/

import React, { useEffect } from "react";



export default function Link(props) {
    const { value, handleFieldValue, multiline, extraProps, rowsMax, shareProps, error, required, tooltip,
        contexthelp, disabled, changefieldto, linkurl, FieldIsSpellCheck, fieldValues, ...otherProps } = props
    const { label, helperText, name, xtype, fullWidth, ...otherConfigs } = otherProps;


    const replacePlaceholders = (str, values) => {
        return Object.keys(values).reduce((acc, key) => {
            const placeholder = `{{${key}}}`;
            return acc.replace(new RegExp(placeholder, 'g'), values[key]);
        }, str);
    };

    
    const processedValue = value ? replacePlaceholders(value, fieldValues) : value;
    const processedLinkUrl = linkurl ? replacePlaceholders(linkurl, fieldValues) : linkurl;

    return (
        <div style={{ color: 'blue', fontSize: '12px' }} onClick={() => { window.open((processedValue || processedLinkUrl), '_blank').focus(); }} className="pointer" >
            <u>{label}</u>
        </div>
    );
}